import { MaterialIconName } from '@/types/common';

export enum EDoctorFilterType {
  SPECIALIST = 'SPECIALIST',
  GOOD_REVIEW = 'GOOD_REVIEW',
  MANY_REVIEW = 'MANY_REVIEW',
  FAST_RESPONSE = 'FAST_RESPONSE',
  PUNCTUAL = 'PUNCTUAL',
  HIGH_RETURN_RATE = 'HIGH_RETURN_RATE',
  LOW_CANCEL_RATE = 'LOW_CANCEL_RATE',
}

export interface DoctorFilterOption {
  type: EDoctorFilterType;
  label: string;
  description: string;
  iconName?: MaterialIconName;
}

export const DOCTOR_FILTER_OPTIONS: DoctorFilterOption[] = [
  {
    type: EDoctorFilterType.SPECIALIST,
    label: '전문의',
    description: '내 증상 전문의',
    iconName: 'badge',
  },
  {
    type: EDoctorFilterType.GOOD_REVIEW,
    label: '후기 좋음',
    description: '후기 평균 4.7 이상',
    iconName: 'thumb_up',
  },
  {
    type: EDoctorFilterType.MANY_REVIEW,
    label: '후기 많음',
    description: '후기 200개 이상',
    iconName: 'chat',
  },
  {
    type: EDoctorFilterType.FAST_RESPONSE,
    label: '응답 빠름',
    description: '진료 신청 3분 내 응답',
    iconName: 'electric_bolt',
  },
  {
    type: EDoctorFilterType.PUNCTUAL,
    label: '시간 잘 지킴',
    description: '진료 지각율 5% 이하',
    iconName: 'alarm_on',
  },
  {
    type: EDoctorFilterType.HIGH_RETURN_RATE,
    label: '재진율 높음',
    description: '재진율 40% 이상',
    iconName: 'heart_smile',
  },
  {
    type: EDoctorFilterType.LOW_CANCEL_RATE,
    label: '취소율 낮음',
    description: '진료 취소율 3% 이하',
    iconName: 'preliminary',
  },
];

export const MAX_FILTER_SELECTION = 3;

export const getSpecialistOnlyFromFilters = (filters: EDoctorFilterType[]): boolean => {
  if (filters.length === 0) {
    return false;
  }
  return filters.includes(EDoctorFilterType.SPECIALIST);
};

export const getHighReviewRatingFromFilters = (filters: EDoctorFilterType[]): boolean => {
  return filters.includes(EDoctorFilterType.GOOD_REVIEW);
};

export const getHighReviewCountFromFilters = (filters: EDoctorFilterType[]): boolean => {
  return filters.includes(EDoctorFilterType.MANY_REVIEW);
};

export const getLoadingMessageByFilterType = (filterType: EDoctorFilterType, categoryName?: string): string => {
  const displayCategoryName = categoryName || '증상/과목';

  const loadingMessageMap: Record<EDoctorFilterType, string> = {
    [EDoctorFilterType.SPECIALIST]: `${displayCategoryName}을(를) 전문으로 하는 의사 찾는 중...`,
    [EDoctorFilterType.GOOD_REVIEW]: '후기 좋은 의사 찾는 중...',
    [EDoctorFilterType.MANY_REVIEW]: '후기 많은 의사 찾는 중...',
    [EDoctorFilterType.FAST_RESPONSE]: '응답 빠른 의사 찾는 중...',
    [EDoctorFilterType.PUNCTUAL]: '진료 시간 잘 지키는 의사 찾는 중...',
    [EDoctorFilterType.HIGH_RETURN_RATE]: '재진율 높은 의사 찾는 중...',
    [EDoctorFilterType.LOW_CANCEL_RATE]: '취소율 낮은 의사 찾는 중...',
  };

  return loadingMessageMap[filterType];
};
